<template>
  <v-card class="ma-3">
    <base-loading v-if="loading" />
    <div v-else class="content">
      <template>
        <v-card style="min-height: 60vh">
          <div>
            <v-form
              id="form"
              ref="form"
              v-model="valid"
              enctype="multipart/form-data"
              class="pa-3"
              lazy-validation
              @submit.prevent="updateUser"
            >
              <v-card>
                <v-list-item-content>
                  <v-card-title class="headline mx-auto">
                    Dados Pessoais
                  </v-card-title>
                  <v-row v-if="!loading" class="pa-3">
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.nome"
                        label="Nome *"
                        name="nome"
                        :rules="requiredRules"
                        required
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.email"
                        name="email"
                        label="Email *"
                        :rules="emailRules"
                        :disabled="$user.get().role !== 'central'"
                        required
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.cpf"
                        v-mask="maskCpf"
                        name="cpf"
                        label="CPF *"
                        :rules="cpfRules"
                        required
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="form.sexo"
                        :items="sexos"
                        :rules="requiredRules"
                        item-text="text"
                        name="sexo"
                        item-value="text"
                        label="Sexo *"
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        v-model="form.estado"
                        autocomplete="autocomplete_off_hack_xfr4!k"
                        label="Estado *"
                        name="estado"
                        :items="estado"
                        :rules="requiredRules"
                        :loading="loadingEstados"
                        :disabled="loadingEstados"
                        item-text="Nome"
                        item-value="CodEstado"
                        required
                        @change="changeCidade"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-autocomplete
                        v-model="form.CodCidade"
                        name="cidade"
                        autocomplete="autocomplete_off_hack_xfr4!k"
                        label="Cidade *"
                        :loading="loadingCidades"
                        :items="cidade"
                        :rules="requiredRules"
                        item-text="Nome"
                        item-value="CodCidade"
                        required
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="form.logradouro"
                        label="Logradouro"
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        v-model="form.numero"
                        label="Numero"
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.bairro"
                        label="Bairro"
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.complemento"
                        label="Complemento"
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.cep"
                        v-mask="maskCep"
                        type="text"
                        label="CEP"
                        name="cep"
                        required
                        @change="edit = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model="form.telCel"
                        v-mask="maskTelCel"
                        :rules="telRules"
                        label="Telefone Celular *"
                        name="telefone"
                        type="tel"
                        required
                        @change="edit = false"
                      />
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-card>
              <v-card class="pa-0 px-5 pb-5">
                <v-card-title class="headline mx-auto ma-2 px-0">
                  Foto do perfil
                </v-card-title>
                <crud-image-uploader
                  ref="form"
                  v-model="form.imagem"
                  dialog-title="Logotipo do Usuario"
                  :editable="editLogo"
                  no-data="img/no-avatar.jpg"
                  @delete="deleteCall"
                  @upload=";(editLogo = true), (edit = false)"
                />
                <v-row justify="center">
                  <v-dialog
                    v-model="dialogRemoveLogo"
                    persistent
                    max-width="290"
                  >
                    <v-card>
                      <v-card-text
                        >Deseja mesmo remover sua foto de perfil? Essa operação
                        não poderá ser desfeita!
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="green darken-1"
                          text
                          :disabled="buttonRemoveLogo"
                          @click="
                            () => {
                              form.imagem = tmpLogo
                              dialogRemoveLogo = false
                            }
                          "
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          color="red darken-1"
                          text
                          :disabled="buttonRemoveLogo"
                          :loading="buttonRemoveLogo"
                          @click="
                            () => {
                              form.imagem = null
                              dialogRemoveLogo = false
                              edit = false
                            }
                          "
                        >
                          Remover
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-card>
              <v-btn
                type="submit"
                :disabled="edit"
                :loading="salvando"
                color="success"
                form="form"
              >
                Salvar Alterações
              </v-btn>

              <router-link :disabled="edit" :to="`/${$user.get().role}/perfil`">
                <v-btn
                  :disabled="edit"
                  color="error"
                  class="ml-3"
                  @click="
                    () => {
                      formDados()
                    }
                  "
                >
                  Cancelar
                </v-btn>
              </router-link>
            </v-form>
          </div>
        </v-card>
      </template>
    </div>
  </v-card>
</template>
<script>
import { validaCPF } from '../../utils/validacoes'

export default {
  data() {
    return {
      edit: true,
      editLogo: false,
      dialogRemoveLogo: false,
      buttonRemoveLogo: false,
      removedLogo: false,
      tmpLogo: '',
      agroindustrias: [],
      salvando: false,
      loading: true,
      loadingEstados: true,
      loadingCidades: false,
      loadingAgroindustrias: true,
      sexos: [{ text: 'Masculino' }, { text: 'Feminino' }],
      maskCpf: '###.###.###-##',
      maskTelCel: '(##) # ####-####',
      maskCep: '##.###-####',
      emailRules: [v => /.+@.+/.test(v) || 'E-mail inválido'],
      telRules: [
        v => !v || v.length === 0 || v.length >= 10 || '* Número inválido',
        v => !!v || '* Obrigatório',
      ],
      cpfRules: [
        v => !!v || '* Obrigatório',
        v => validaCPF(v) || '* CPF inválido',
      ],
      requiredRules: [v => !!v || '* Obrigatório'],
      valid: false,
      defaultImage:
        'data:image/png;base64,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',
      form: {
        imagem: null,
        CodPessoa: null, // código do Usuario
        nome: null,
        email: null,
        cpf: null,
        sexo: null,
        telCel: null,
        estado: null,
        CodCidade: null,
        bairro: null,
        logradouro: null,
        numero: null,
        complemento: null,
        cep: null,
      },
      estado: [],
      cidade: [],
      endereco: [],
    }
  },
  created() {
    this.formDados()
  },
  methods: {
    deleteCall() {
      this.dialogRemoveLogo = true
      this.buttonRemoveLogo = false
    },

    updateUser() {
      this.valid = this.$refs.form.validate()

      if (!this.valid) {
        this.Swal.fire(
          'Atenção',
          'Preencha os itens obrigatórios sinalizados com ("*").',
          'warning',
        )
        return false
      } else {
        if (this.form.CodPessoa) {
          this.salvando = true
          this.edit = true
          // ATUALIZAR DADOS DO USUARIO
          this.api.update
            .perfil(this.form.CodPessoa, this.form)
            .then(response => {
              this.Swal.fire({
                title: 'Sucesso',
                text: response,
                icon: 'success',
                showConfirmButton: false,
                timer: 2000,
              }).then(() => {
                this.$root.$emit('profileUpdate', this.form.nome)
              })
              this.salvando = false
              this.edit = true
            })
            .catch(reject => {
              this.Swal.fire('Atenção', reject, 'warning')
              this.salvando = false
              this.edit = true
            })
        }
      }
    },
    formDados() {
      let data = this.$user.get()
      this.loading = true
      this.loadEndereco(data.pessoa.CodPessoa)
      this.form.imagem = data.avatar
      this.tmpLogo = data.avatar
      this.form.CodPessoa = data.pessoa.CodPessoa
      this.form.nome = data.pessoa.pessoafisica.Nome
      this.form.email = data.pessoa.email
      this.form.cpf = data.pessoa.pessoafisica.Cpf
      this.form.sexo = data.pessoa.pessoafisica.sexo
      this.form.telCel = data.pessoa.TelCel
      this.edit = true
      this.valid = true
    },
    async loadEndereco(CodPessoa) {
      this.api.get.endereco(CodPessoa).then(data => {
        this.form.CodCidade = data.CodCidade
        this.form.bairro = data.Bairro
        this.form.logradouro = data.Logradouro
        this.form.numero = data.Numero
        this.form.complemento = data.Complemento
        this.form.cep = data.Cep
        this.form.estado = data.CodEstado
        this.loadEstado()
        this.loadCidade(this.form.estado)
      })
    },
    async loadEstado() {
      this.api.get.estados().then(data => {
        this.estado = data
        this.loadingEstados = false
      })
    },
    async loadCidade(CodEstado) {
      this.loadingCidades = true
      this.api.get.cidades(CodEstado).then(data => {
        this.cidade = data
        this.loadingCidades = false
        this.loading = false
      })
    },
    changeCidade() {
      this.loadCidade(this.form.estado)
      this.edit = false
    },
  },
}
</script>
<style>
html {
  overflow: auto !important;
}

input[type='file'] {
  display: none;
}

#foto {
  background-color: #3498db;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  padding: 6px 20px;
}

.index {
  z-index: 1;
}
</style>
